define(
    'views/secured/explorer/details/details.html',[
        "durandal/system",
        "durandal/app",
        "services/config",
        "services/eventbroker"
    ],
    function (system, app, config, eventBroker) {

        var view = {};

        _.defer(function () {
            eventBroker.on(view, config.events.explorer.layout.resizedDetailsPane, function (layout) {
                resizePreviewPane(layout);
            });
        });

        return view;

        function resizePreviewPane(layout) {
            var eastCurrentSize = layout.state.east.outerHeight;
            var tabHeight = $("ul.nav.nav-tabs").outerHeight();

            $(".tab-content").outerHeight(eastCurrentSize - tabHeight);
            $("#columns").outerHeight(eastCurrentSize - tabHeight);
            $("#columns .library-listview").outerHeight(eastCurrentSize - tabHeight - 200);
            //$("#columns #library-listview-container").outerHeight(eastCurrentSize - tabHeight - 120);

            //console.warn(eastCurrentSize - tabHeight);
            //console.warn($("#explorer-details").outerHeight());
        }

});
